import {
  MainWrapper,
  TitleWrapper,
  Title,
  InfosWrapper,
  InfoMainWrapper,
  InfoTitle,
  ItemTitle,
  DateWrapper,
  DescriptionWrapper,
  ExperienceWrapper,
  ExperienceLogo,
  ExperienceInfoWrapper,
  Name,
  Position,
  DataLocation,
  Wrapper,
  AvatarWrapper,
} from "../../../student-dashboard/ProfileInfo/MoreInfos/styles";
import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import LockIcon from "@mui/icons-material/Lock";
import { useTranslation } from "react-i18next";
import { formatDateWithNumbers } from "../../../../../../utils/formaters/formatDate";
import { useState } from "react";
import { UnlockButton } from "../BasicInformation/styles";
import UnlockFieldModal from "../UnlockFieldModal/UnlockFieldModal";
import LockedData from "../BasicInformation/LockedData";

export default function MoreInformation({ data }: any) {
  const { t } = useTranslation();
  const [openUnlockModal, setOpenUnlockModal] = useState<boolean>(false);

  return (
    <>
      <MainWrapper>
        <TitleWrapper>
          <Title>{t("more_info.title")}</Title>
          {!data.email && (
            <UnlockButton onClick={() => setOpenUnlockModal(true)}>
              {t("unlock_infos")}
              <LockIcon sx={{ fontSize: "15px" }} />
            </UnlockButton>
          )}
        </TitleWrapper>
        <InfosWrapper>
          <InfoMainWrapper>
            <InfoTitle>{t("more_info.experiences")}</InfoTitle>
            {data.email ? (
              data && data?.workExperience?.length > 0 ? (
                data?.workExperience?.map((experience: any) => {
                  return (
                    <ExperienceWrapper>
                      {experience?.companyLogo ? (
                        <ExperienceLogo src={experience.companyLogo} />
                      ) : (
                        <AvatarWrapper>
                          <BusinessCenterRoundedIcon sx={{ color: "white" }} />
                        </AvatarWrapper>
                      )}
                      <ExperienceInfoWrapper>
                        <Name>{experience.enterpriseName}</Name>
                        <Position>{experience.position}</Position>
                        <DataLocation>
                          {formatDateWithNumbers(
                            experience.startMonth,
                            experience.startYear,
                            experience.endMonth,
                            experience.endYear
                          )}
                          &nbsp; | {experience.location}
                        </DataLocation>
                      </ExperienceInfoWrapper>
                    </ExperienceWrapper>
                  );
                })
              ) : (
                <ItemTitle>
                  {t(
                    "editProfile.edit_candidate_profile.experience.no_experiences"
                  )}
                </ItemTitle>
              )
            ) : (
              <LockedData />
            )}
          </InfoMainWrapper>
          <InfoMainWrapper>
            <InfoTitle>{t("more_info.educations")}</InfoTitle>
            {data.email ? (
              data && data?.educations?.length > 0 ? (
                data?.educations?.map((education: any) => {
                  return (
                    <Wrapper>
                      <ItemTitle>
                        {education.fieldOfStudy} | {education.educationName}
                      </ItemTitle>

                      <DateWrapper>
                        {formatDateWithNumbers(
                          education.startMonth,
                          education.startYear,
                          education.endMonth,
                          education.endYear
                        )}
                      </DateWrapper>
                      <DescriptionWrapper>
                        {education.description}
                      </DescriptionWrapper>
                    </Wrapper>
                  );
                })
              ) : (
                <ItemTitle>
                  {t(
                    "editProfile.edit_candidate_profile.education.no_educations"
                  )}
                </ItemTitle>
              )
            ) : (
              <LockedData />
            )}
          </InfoMainWrapper>
          <InfoMainWrapper>
            <InfoTitle>{t("more_info.accomplishments")}</InfoTitle>
            {data.email ? (
              data && data?.accomplishments?.length > 0 ? (
                data?.accomplishments?.map((accomplishment: any) => {
                  return (
                    <Wrapper>
                      <ItemTitle>{accomplishment.accomplishmentName}</ItemTitle>
                      <DateWrapper>
                        {formatDateWithNumbers(
                          accomplishment.startMonth,
                          accomplishment.startYear,
                          accomplishment.endMonth,
                          accomplishment.endYear
                        )}
                      </DateWrapper>
                      <DescriptionWrapper>
                        {accomplishment.description}
                      </DescriptionWrapper>
                    </Wrapper>
                  );
                })
              ) : (
                <ItemTitle>
                  {t(
                    "editProfile.edit_candidate_profile.accomplishment.no_accomplishments"
                  )}
                </ItemTitle>
              )
            ) : (
              <LockedData />
            )}
          </InfoMainWrapper>
          <InfoMainWrapper>
            <InfoTitle>Certifications</InfoTitle>
            {data.email ? (
              data && data?.certifications?.length > 0 ? (
                data?.certifications?.map((certification: any) => {
                  return (
                    <Wrapper>
                      <ItemTitle>{certification.name}</ItemTitle>
                      <DateWrapper>
                        {formatDateWithNumbers(
                          certification.startMonth,
                          certification.startYear,
                          certification.endMonth,
                          certification.endYear
                        )}
                      </DateWrapper>
                      <DescriptionWrapper>
                        {certification.description}
                      </DescriptionWrapper>
                    </Wrapper>
                  );
                })
              ) : (
                <ItemTitle>
                  {t(
                    "editProfile.edit_candidate_profile.certification.no_certifications"
                  )}
                </ItemTitle>
              )
            ) : (
              <LockedData />
            )}
          </InfoMainWrapper>
        </InfosWrapper>
      </MainWrapper>
      <UnlockFieldModal
        isProfile
        openUnlockModal={openUnlockModal}
        setOpenUnlockModal={setOpenUnlockModal}
        candidateId={data.candidateId}
        candidateUserId={data.userId}
      />
    </>
  );
}
